(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mxd-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mxdCarouselReady) return;
    window.__mxdCarouselReady = true;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function Carousel(root) {
      this.root = root;
      this.track = root.querySelector('[data-mxd-track]');
      this.viewport = root.querySelector('[data-mxd-viewport]');
      this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-mxd-slide]'));
      this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-mxd-dot]'));
      this.prevBtn = root.querySelector('[data-mxd-prev]');
      this.nextBtn = root.querySelector('[data-mxd-next]');
      this.toggleBtn = root.querySelector('[data-mxd-toggle]');
      this.count = this.slides.length;
      this.index = 0;
      this.timer = null;
      this.startX = null;
      this.deltaX = 0;
      this.userPaused = false;
      this.autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion && this.count > 1;
      var secs = parseInt(root.getAttribute('data-interval'), 10);
      this.interval = (isNaN(secs) ? 5 : Math.max(2, secs)) * 1000;

      // No autoplay (reduced-motion or single slide) -> the pause/play control is meaningless.
      if (this.toggleBtn && !this.autoplay) this.toggleBtn.hidden = true;

      if (!this.track || this.count === 0) return;
      this.bind();
      this.render(false);
      this.start();
    }

    Carousel.prototype.bind = function () {
      var self = this;

      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(self.index - 1); self.restart(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(self.index + 1); self.restart(); });

      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          self.go(parseInt(dot.getAttribute('data-mxd-dot'), 10));
          self.restart();
        });
      });

      this.root.addEventListener('mouseenter', function () { self.stop(); });
      this.root.addEventListener('mouseleave', function () { self.maybeStart(); });
      this.root.addEventListener('focusin', function () { self.stop(); });
      this.root.addEventListener('focusout', function () { self.maybeStart(); });

      this.root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); self.restart(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); self.restart(); }
      });

      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', function () {
          self.userPaused = !self.userPaused;
          self.toggleBtn.setAttribute('aria-pressed', self.userPaused ? 'true' : 'false');
          self.toggleBtn.setAttribute('aria-label', self.userPaused ? 'Reproducir' : 'Pausar');
          var pauseIcon = self.toggleBtn.querySelector('[data-mxd-toggle-pause]');
          var playIcon = self.toggleBtn.querySelector('[data-mxd-toggle-play]');
          if (pauseIcon && playIcon) { pauseIcon.hidden = self.userPaused; playIcon.hidden = !self.userPaused; }
          // Explicit play overrides hover/focus auto-pause; explicit pause sticks.
          if (self.userPaused) self.stop(); else self.start();
        });
      }

      this._onVis = function () { if (document.hidden) self.stop(); else self.maybeStart(); };
      document.addEventListener('visibilitychange', this._onVis);

      // Swipe via Pointer Events on the viewport (arrows live outside it).
      var vp = this.viewport;
      if (vp && window.PointerEvent) {
        vp.addEventListener('pointerdown', function (e) {
          self.startX = e.clientX;
          self.deltaX = 0;
          self.stop();
        });
        vp.addEventListener('pointermove', function (e) {
          if (self.startX === null) return;
          self.deltaX = e.clientX - self.startX;
        });
        var end = function () {
          if (self.startX === null) return;
          var dx = self.deltaX;
          self.startX = null;
          self.deltaX = 0;
          if (Math.abs(dx) > 40) { self.go(dx < 0 ? self.index + 1 : self.index - 1); }
          self.maybeStart();
        };
        vp.addEventListener('pointerup', end);
        vp.addEventListener('pointercancel', end);
        vp.addEventListener('pointerleave', end);
      }
    };

    Carousel.prototype.go = function (i, animate) {
      this.index = ((i % this.count) + this.count) % this.count;
      this.render(animate);
    };

    Carousel.prototype.render = function (animate) {
      var self = this;
      if (animate === false) this.track.style.transition = 'none';
      this.track.style.transform = 'translateX(' + (-this.index * 100) + '%)';
      if (animate === false) {
        void this.track.offsetWidth; // flush, then restore the transition
        this.track.style.transition = '';
      }
      this.slides.forEach(function (s, idx) {
        var active = idx === self.index;
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        var link = s.querySelector('a');
        if (link) link.tabIndex = active ? 0 : -1;
      });
      this.dots.forEach(function (d, idx) {
        var active = idx === self.index;
        d.classList.toggle('is-active', active);
        if (active) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    };

    Carousel.prototype.start = function () {
      if (!this.autoplay || this.userPaused || this.timer || document.hidden) return;
      var self = this;
      this.timer = setInterval(function () { self.go(self.index + 1); }, this.interval);
    };
    // Resume only if no pause source is currently active (explicit pause, tab hidden, hover, focus).
    Carousel.prototype.maybeStart = function () {
      if (this.userPaused || document.hidden) return;
      if (this.root.matches && this.root.matches(':hover')) return;
      if (this.root.contains(document.activeElement)) return;
      this.start();
    };
    Carousel.prototype.stop = function () {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    };
    Carousel.prototype.restart = function () { this.stop(); this.maybeStart(); };
    Carousel.prototype.destroy = function () {
      this.stop();
      if (this._onVis) { document.removeEventListener('visibilitychange', this._onVis); this._onVis = null; }
      if (this.root) this.root.__mxd = null;
    };

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mxd-carousel]');
      Array.prototype.forEach.call(roots, function (root) {
        if (root.__mxd) root.__mxd.destroy();
        root.__mxd = new Carousel(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // Theme editor: re-init on reload, tear down on unload, jump to selected block.
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector && e.target.querySelector('[data-mxd-carousel]');
      if (root && root.__mxd) root.__mxd.destroy();
    });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest && e.target.closest('[data-mxd-carousel]');
      if (!root || !root.__mxd) return;
      var slide = e.target.closest('[data-mxd-slide]');
      var idx = slide ? root.__mxd.slides.indexOf(slide) : -1;
      if (idx >= 0) { root.__mxd.stop(); root.__mxd.go(idx); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest && e.target.closest('[data-mxd-carousel]');
      if (root && root.__mxd) root.__mxd.maybeStart();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
